import { Action, createReducer, on } from '@ngrx/store'

import { save_feedback_success_action } from '../action/feedback.action'
import { feedbackState, initialFeedbackState } from '../state/feedback.state'
export function feedbackReducer(state: feedbackState, action: Action) {
  return _feedbackReducer(state, action)
}

export const _feedbackReducer = createReducer(
  initialFeedbackState,
  on(save_feedback_success_action, (state, { feedback }) => {
    return {
      ...state,
      search: feedback
    }
  })
)
